import { usePeopleAPI } from "@certn/legacy-api";

const UK_COUNTRIES: Record<string, string> = {
  ENG: "England",
  WLS: "Wales",
  SCT: "Scotland",
  NIR: "Northern Ireland",
};

export function useCountryName() {
  const { data: countries } = usePeopleAPI(
    "/internal/people/addresses/countries/"
  );

  return (code: string) => {
    if (code in UK_COUNTRIES) {
      return `United Kingdom (${UK_COUNTRIES[code]})`;
    }

    return countries?.find(({ alpha_2 }) => alpha_2 === code)?.name;
  };
}

export function useProvinceName(country: string) {
  const { data: subdivisions } = usePeopleAPI(
    "/internal/people/addresses/country-subdivisions/",
    { alpha_2: country }
  );

  return (value: string) =>
    subdivisions?.find(({ code }) => code === value)?.name;
}
